import axios from "axios";
// import router from "../router/index";
/* global wx */
// 全局消息显示状态控制

// 环境配置
if (process.env.NODE_ENV == "development") {
 // axios.defaults.baseURL = "https://ysj.hnykzd.com";
  axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV == "debug") {
  axios.defaults.baseURL = "";
} else if (process.env.NODE_ENV == "production") {
  // 根据实际生产环境配置
  // axios.defaults.baseURL = "正式环境地址";
 // axios.defaults.baseURL = "https://ysj.hnykzd.com";
}

// 全局配置
axios.defaults.timeout = 30000;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(
  (config) => {
   
    //console.log('获取到的 token:', token);
    // window.alert(token);
    const token = window.localStorage.getItem("token");
    //如果 token 存在且包含 #wechat_redirect，则去除该部分
    // if (token && token.includes('#')) {
    //   token = token.split('#')[0];
    // }
    
    console.log('获取到的 token:', token);
    if (token) {
      config.headers = {
        ...config.headers,
        token: token,
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if ([303, 401].includes(response.data.code)) {
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      // localStorage.removeItem("roleList");
      // router.replace({
      //   path: "/Login",
      //   query: {
      //     redirect: router.currentRoute.fullPath,
      //   },
      // });
      // router.replace("/login");


      wx.miniProgram.postMessage({
        data: {
          url: '401',
          type: 'back',
          message: '来自H5页面的消息'
        }
      });
      //  window.alert(response.data.code)
       //wx.miniProgram.navigateBack()
      // 跳转到登录页
      wx.miniProgram.navigateTo({
        url: '/pages/login/login?redirect=401'
      });
      // 提取具体的错误信息并抛出
      const errorMessage = response.data.msg || '未知错误';
      return Promise.reject(new Error(errorMessage));
    }

    // 检查响应状态是否为200，并根据code字段判断是否显示消息
    if (response.status === 200) {
      if (response.data.code === 400) {
        // 如果code为400，表示请求错误，显示错误消息
        window.alert(response.data.msg);
        return Promise.reject(response);
      } else {
        return Promise.resolve(response);
      }
    }

    return Promise.reject(response);
  },
  (error) => {
    // 网络错误处理
    if (!error.response) {
      // if (error.code === "ERR_NETWORK") {
      // }
      return Promise.reject(error);
    }

    // HTTP状态码处理
    const status = error.response.status;
    //   const resMessage = error.response.data?.message;

    switch (status) {
      case 401:

        // router.replace({
        //   path: "/Login",
        //   query: {
        //     redirect: router.currentRoute.fullPath,
        //   },
        // });
        break;
      case 403:

        break;
      case 404:

        break;
      case 500:

        break;
      default:

    }

    return Promise.reject(error);
  }
);

// 封装GET请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params })
      .then((res) => resolve(res.data))
      .catch((err) => {
        // 移除这里的错误处理，因为已经在拦截器中处理过了
        reject(err);
      });
  });
}

// 封装POST请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => resolve(res.data))
      .catch((err) => {
        // 移除这里的错误处理，因为已经在拦截器中处理过了
        reject(err);
      });
  });
}

// 无Loading的POST请求
export function postNotLoading(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err.message));
  });
}

// 无Loading的GET请求
export function getNotLoading(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err.response?.data || err.message));
  });
}

// 文件上传封装
export const uploadFileRequest = (url, data) => {
  return axios({
    method: "post",
    url,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
